/* eslint-disable max-len */
const React = require('react');

const Play = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
>
    <path
      fill="#fff"
      fillOpacity="1"
      fillRule="evenodd"
      d="M3.438 2.116a.9.9 0 01.879-.003l9.24 5.143A.853.853 0 0114 8c0 .308-.17.592-.443.744l-9.24 5.143a.9.9 0 01-.879-.003.853.853 0 01-.438-.741V2.857c0-.305.167-.588.438-.741z"
      clipRule="evenodd"
   />
  </svg>
);

module.exports = Play;

